
import TitleService from 'title-service';
import './PreviewModalDetail.scss';
export interface PreviewModelDetails {
    year: string,
    duration: string,
    description: string,
    rating?: string,
    distributor: string,
    genreTags: TagModel[],
    tags: TagModel[]
}
export interface TagModel {
    title: string;
    url: string;
}
export default function PreviewModalDetail(props: PreviewModelDetails) {
    return (
        <div className="previewModal--detailsMetadata detail-modal has-smaller-buttons  "
            data-uia="previewModal--detailsMetadata">
            <div className="previewModal--detailsMetadata-left">
                <div className="previewModal--detailsMetadata-info">
                    <div className="">
                        <div data-uia="videoMetadata--container" className="videoMetadata--container">
                            <div className="videoMetadata--first-line">
                                <span className="match-score-wrapper no-rating">
                                    <div className="show-match-score rating-inner">
                                        <div className="meta-thumb-container thumb-down">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="thumb thumb-down-filled svg-icon svg-icon-thumb-thumb-down-filled">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M10.593 17.7442L10.687 18.4959C10.8658 19.9265 12.0819 21 13.5236 21C13.7867 21 14 20.7867 14 20.5236V17.2868C14 17.0994 14.0527 16.9157 14.152 16.7568L16.0926 13.6519C16.3548 13.2323 16.7633 12.9248 17.2391 12.7888L19.2747 12.2072C19.704 12.0846 20 11.6922 20 11.2457V5.68387C20 5.30618 19.6938 5 19.3161 5C18.126 5 16.9565 4.68942 15.9232 4.09895L15.75 4C14.6032 3.34469 13.3053 3 11.9844 3H11H8H7.5C6.67157 3 6 3.67157 6 4.5C6 4.88418 6.14443 5.23462 6.38195 5.5H6C5.17157 5.5 4.5 6.17157 4.5 7C4.5 7.53991 4.78525 8.0132 5.21328 8.27737C4.522 8.41118 4 9.01963 4 9.75C4 10.5784 4.67157 11.25 5.5 11.25H5.67055C5.26638 11.5187 5 11.9783 5 12.5C5 13.3284 5.67157 14 6.5 14H10.875L10.593 16.2558C10.5312 16.75 10.5312 17.25 10.593 17.7442Z" fill="currentColor">
                                                </path>
                                            </svg>
                                        </div>
                                        <div className="meta-thumb-container thumb-up">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="thumb thumb-up-filled svg-icon svg-icon-thumb-thumb-up-filled">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M13.407 6.25579L13.313 5.50407C13.1342 4.07353 11.9181 3 10.4764 3C10.2133 3 10 3.21331 10 3.47644V6.7132C10 6.90062 9.94733 7.08427 9.848 7.2432L7.90742 10.3481C7.64516 10.7677 7.23665 11.0752 6.76086 11.2112L4.72528 11.7928C4.29598 11.9154 4 12.3078 4 12.7543V18.3161C4 18.6938 4.30618 19 4.68387 19C5.874 19 7.04352 19.3106 8.07684 19.9011L8.25 20C9.39679 20.6553 10.6947 21 12.0156 21H13H16H16.5C17.3284 21 18 20.3284 18 19.5C18 19.1158 17.8556 18.7654 17.6181 18.5H18C18.8284 18.5 19.5 17.8284 19.5 17C19.5 16.4601 19.2147 15.9868 18.7867 15.7226C19.478 15.5888 20 14.9804 20 14.25C20 13.4216 19.3284 12.75 18.5 12.75H18.3294C18.7336 12.4813 19 12.0217 19 11.5C19 10.6716 18.3284 10 17.5 10H13.125L13.407 7.74421C13.4688 7.24999 13.4688 6.75001 13.407 6.25579Z" fill="currentColor">
                                                </path>
                                            </svg>
                                        </div>
                                    </div>
                                </span>
                            </div>
                            <div className="videoMetadata--second-line">
                                <div className="year">{props.year}</div>
                                <a href="#about">
                                    <span className="maturity-rating ">
                                        <span className="maturity-number">TV-{props.rating || TitleService('NR')}</span>
                                    </span>
                                </a>
                                <span className="duration">{props.duration}
                                </span>
                                <span className="player-feature-badge">HD</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="css-s5xdrg">
                </div>
                <p className="preview-modal-synopsis previewModal--text" data-uia="preview-modal-synopsis">
                    <div className="ptrack-content">{props.description}</div>
                </p>
            </div>
            <div className="previewModal--detailsMetadata-right">
                {props?.distributor && <div className="previewModal--tags" data-uia="previewModal--tags-person">
                    <span className="previewModal--tags-label">Distribution&nbsp;:</span>
                    <span className="tag-item" data-uia="tag-item">
                        <a href="javascript:void(0);">{props.distributor}</a>
                    </span>
                </div>}
                {props?.tags?.length > 0 && <div className="previewModal--tags" data-uia="previewModal--tags-genre">
                    <span className="previewModal--tags-label">Genres&nbsp;:</span>
                    {props.tags.map((tag, index) => {
                        let comma = ',';
                        if (index === props.tags.length - 1) {
                            comma = '';
                        }
                        return (<span className="tag-item" key={`tag-${index}`} data-uia="tag-item">
                            <a href={tag.url}> {tag.title}{comma} </a>
                        </span>)
                    })}
                </div>}
                {props?.genreTags?.length > 0 && <div className="previewModal--tags" data-uia="previewModal--tags-genre">
                    {<span className="previewModal--tags-label">Ce programme est&nbsp;:</span>}
                    {props.genreTags.map((tag, index) => {
                        let comma = ',';
                        if (index === props.tags.length - 1) {
                            comma = '';
                        }
                        return (<span className="tag-item" key={`tag-${index}`} data-uia="tag-item">
                            <a href={tag.url}> {tag.title}{comma} </a>
                        </span>)
                    })}
                </div>}
            </div>
        </div>
    );
}